import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, emptyEnvelopeSchema, requiredPayloadEnvelope, } from '../envelope.js';
import { tokenRefreshSchema, verificationTimingSchema } from '../common/schemas.js';
/** admin 2단계 로그인(이메일 OTP) 완료 후 내려주는 AT·프로필 묶음이다. */
const adminLoginVerifiedSchema = tokenRefreshSchema.extend({
    /** 로그인한 AdminUser id다. */
    id: z.string(),
    /** 직원 이메일이다. */
    email: z.string(),
    /** 콘솔 표시 이름이다. */
    name: z.string(),
    /** `super_admin` 또는 `admin`이다. */
    role: z.string(),
    /** 임시 비밀번호를 아직 바꾸지 않았으면 true다. */
    isTempPassword: z.boolean(),
});
const c = initContract();
/** admin-api 인증 — 이메일·비밀번호 1차 검증 후 항상 이메일 OTP(MFA)를 거친다. RT는 `lunacast_admin_rt` 쿠키다. */
export const adminAuthContract = c.router({
    /** 1단계: 비밀번호 검증 성공 시 AT를 내리지 않고 이메일 OTP만 발송한다. */
    login: {
        method: 'POST',
        path: '/auth/login',
        body: z.object({
            /** 직원 로그인 이메일이다. */
            email: z.string().optional(),
            /** 평문 비밀번호다. admin-web은 아직 JWE 봉인 전이며, 서버가 직접 검증한다. */
            password: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(verificationTimingSchema),
            ...commonErrorResponses,
        },
    },
    /** 2단계: 이메일 OTP 확인 후 AT·RT·프로필을 발급한다. */
    verifyOtp: {
        method: 'POST',
        path: '/auth/login/verify-otp',
        body: z.object({
            /** OTP를 받은 이메일이다. */
            email: z.string().optional(),
            /** 이메일로 받은 인증번호다. */
            code: z.string().optional(),
            /** DPoP proof JWT다. AT 바인딩에 쓴다. */
            dpopProof: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(adminLoginVerifiedSchema),
            ...commonErrorResponses,
        },
    },
    /** RT 쿠키로 AT를 재발급한다. */
    refresh: {
        method: 'POST',
        path: '/auth/refresh',
        body: c.noBody(),
        responses: {
            200: requiredPayloadEnvelope(tokenRefreshSchema),
            ...commonErrorResponses,
        },
    },
    /** RT를 폐기하고 세션을 종료한다. */
    logout: {
        method: 'POST',
        path: '/auth/logout',
        body: c.noBody(),
        responses: {
            200: emptyEnvelopeSchema,
            ...commonErrorResponses,
        },
    },
    /** 임시 비밀번호 로그인 직후 새 비밀번호로 바꾼다. 성공 시 새 AT를 내려준다. */
    resetTempPassword: {
        method: 'PATCH',
        path: '/auth/reset-temp',
        body: z.object({
            /** 현재(임시) 비밀번호다. */
            currentPassword: z.string().optional(),
            /** 설정할 새 비밀번호다. */
            newPassword: z.string().optional(),
            /** DPoP proof JWT다. */
            dpopProof: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(tokenRefreshSchema),
            ...commonErrorResponses,
        },
    },
});
//# sourceMappingURL=auth.contract.js.map